const CONTENT_MARGIN = 14;
const SUBMENU_ALIGN_OFFSET = -4;
const SUBMENU_SIDE_OFFSET = 6;
const ROOT_MENU_SIDE_OFFSET = 4;
const LIST_PADDING_Y = 6;
const DEFAULT_VIEWPORT_MAX_HEIGHT = 640;
const DEFAULT_COLLISION_PADDING = {
  right: 16,
  left: 16
};
const ASIDE_SCROLL_THRESHOLD = 1;

export { ASIDE_SCROLL_THRESHOLD, CONTENT_MARGIN, DEFAULT_COLLISION_PADDING, DEFAULT_VIEWPORT_MAX_HEIGHT, LIST_PADDING_Y, ROOT_MENU_SIDE_OFFSET, SUBMENU_ALIGN_OFFSET, SUBMENU_SIDE_OFFSET };
//# sourceMappingURL=constants.mjs.map
